/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Showcase_Neighborhood_TitleInputs */

const en_meta_showcase_neighborhood_title = /** @type {(inputs: Meta_Showcase_Neighborhood_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hotel Area Guide & Interactive Map for Guests | Lindevo`)
};

const lv_meta_showcase_neighborhood_title = /** @type {(inputs: Meta_Showcase_Neighborhood_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apkārtnes karte viesnīcas mājaslapā — demo | Lindevo`)
};

/**
* | output |
* | --- |
* | "Hotel Area Guide & Interactive Map for Guests \| Lindevo" |
*
* @param {Meta_Showcase_Neighborhood_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_showcase_neighborhood_title = /** @type {((inputs?: Meta_Showcase_Neighborhood_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Showcase_Neighborhood_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_showcase_neighborhood_title(inputs)
	return en_meta_showcase_neighborhood_title(inputs)
});